module.exports = __webpack_public_path__ + "media/s03_mask.2bd80582.mp4";